/*
 * Line icons drawn as inline SVG — consistent 1.6px strokes and rounded ends.
 * Text characters were standing in for these, which never looks deliberate.
 */
const PATHS = {
  shield: <><path d="M12 3.2 5 6v5.4c0 4.2 2.9 7.4 7 8.6 4.1-1.2 7-4.4 7-8.6V6l-7-2.8Z" /><path d="m9.2 12.1 2 2 3.6-3.9" /></>,
  heart: <path d="M12 19.6s-6.8-4-6.8-8.6a3.9 3.9 0 0 1 6.8-2.6 3.9 3.9 0 0 1 6.8 2.6c0 4.6-6.8 8.6-6.8 8.6Z" />,
  clock: <><circle cx="12" cy="12" r="8" /><path d="M12 7.6V12l3 1.8" /></>,
  calendar: <><rect x="4" y="5.5" width="16" height="14" rx="2.5" /><path d="M4 10h16M9 3.5v4M15 3.5v4" /></>,
  message: <path d="M20 12.5a6.6 6.6 0 0 1-6.9 6.5 8 8 0 0 1-3-.5L5 20l1.4-4a6.2 6.2 0 0 1-1.4-3.9A6.6 6.6 0 0 1 11.9 6h.6a6.6 6.6 0 0 1 7.5 6.5Z" />,
  home: <><path d="M4.5 10.5 12 4.5l7.5 6" /><path d="M6.5 9.8V19h11V9.8" /><path d="M10 19v-4.6h4V19" /></>,
  users: <><circle cx="9.5" cy="9" r="3.2" /><path d="M4 19.2c0-3 2.5-4.8 5.5-4.8s5.5 1.8 5.5 4.8" /><path d="M16.2 6.2a3 3 0 0 1 0 5.6M17.5 14.8c2 .5 3.5 2 3.5 4.4" /></>,
  sparkle: <><path d="M12 4.5 13.6 9l4.4 1.6L13.6 12l-1.6 4.5L10.4 12 6 10.6 10.4 9 12 4.5Z" /><path d="M18 16.5v3M16.5 18h3" /></>,
  check: <path d="m5.5 12.5 4 4 9-9.5" />,
  arrow: <><path d="M5 12h13" /><path d="m12.5 6 6 6-6 6" /></>,
};

export default function Icon({ name, size = 22, className = '', strokeWidth = 1.6 }) {
  const path = PATHS[name];
  if (!path) return null;
  return (
    <svg
      className={`icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}
